module.exports = __webpack_public_path__ + "img/温然.043e7ee1.jpg";